import React, { useState, useEffect, useCallback } from 'react'
import api from '../api'

import { ClockCircleOutlined } from '@ant-design/icons'
import { Alert, Input, Table, message, Button, Drawer, Tag, Typography, Descriptions, Select } from 'antd'


const { Paragraph, Text } = Typography
const { TextArea } = Input

//  表格 [用户]
const columnsUser = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'NID',
        dataIndex: 'nid',
        key: 'nid',
    },
    {
        title: '用户名',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '购买时间',
        dataIndex: 'ctime',
        key: 'ctime',
    },
];

//  控制台-资源托管系统
function ChgV2(props) {
    const [data, setData] = useState([])
    const [chgData, setChgData] = useState({ nid: '', name: '', language: '', useNum: 0, code: '', users: [], ctime: '' })
    const [chgAddData, setChgAddData] = useState({ name: '', language: 'js', code: '', version: '1.1.0' })
    const [loading, setLoading] = useState(true)
    const [update, setUpdate] = useState(null)
    const [page, setPage] = useState('all')


    useEffect(() => {
        // let name = 'userChgData'
        // if (localStorage.getItem(name)) {
        //     setData(JSON.parse(localStorage.getItem(name)))
        //     setLoading(false)
        // }

        api.post('/api/v2/resource', {
            type: 'get'
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data

                    // console.log(res.data.data.data);

                    // localStorage.setItem(name, JSON.stringify(Data))
                    setData(Data)
                    setLoading(false)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [update])


    //  表格
    const columns = [
        {
            title: 'ID',
            dataIndex: 'nid',
            key: 'nid',
        },
        {
            title: '资源名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '版本',
            dataIndex: 'version',
            key: 'version',
        },
        // {
        //     title: '开发语言',
        //     key: 'language',
        //     dataIndex: 'language',
        //     render: ((tag) => {
        //         return (
        //             <Tag color="processing">{tag ? tag === 'js' ? 'Js' : 'Lua' : 'Lua'}</Tag>
        //         )
        //     }),
        // },
        // {
        //     title: '使用数',
        //     dataIndex: 'useNum',
        //     key: 'useNum',
        // },
        {
            title: '创建时间',
            dataIndex: 'ctime',
            key: 'ctime',
        },
        {
            title: '更新时间',
            dataIndex: 'etime',
            key: 'etime',
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Tag color="processing" className='clogs-check' onClick={() => {
                    setChgData(record)
                    setPage('details')
                }}>管理</Tag>
            ),
        },
    ];


    // function onClick(event) {
    //     let name = event.target.className
    //     let arr = name.split(/\s+/)
    //     for (let i = 0; i < arr.length; i++) {
    //         if (arr[i] === 'clogs-check') {
    //             let nid = parseInt(event.target.dataset.nid)
    //             let Data = localStorage.getItem('userChgData') ? JSON.parse(localStorage.getItem('userChgData')) : []
    //             for (let i = 0; i < Data.length; i++) {
    //                 if (parseInt(Data[i].nid) === nid) {
    //                     setChgData(Data[i])
    //                 }
    //             }
    //             setPage('details')
    //             return
    //         }
    //     }
    // }

    function onChange(value) {
        setChgData((data) => ({
            ...data,
            name: value
        }))
    }

    const onAddChange = useCallback((e) => {
        setChgAddData({
            ...chgAddData,
            [e.target.name]: e.target.value,
        })
    }, [chgAddData])

    const saveData = useCallback(() => {
        let Data = chgData
        api.post('/api/v2/resource', {
            type: 'set',
            data: Data,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    setPage('all')
                    message.success('已保存资源修改')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [chgData])

    const sendData = useCallback(() => {
        let Data = chgAddData
        if (Data.name.length <= 0) {
            return message.error('请输入资源名称')
        }
        api.post('/api/v2/resource', {
            type: 'add',
            data: Data,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    setPage('all')
                    message.success('已创建资源')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [chgAddData])

    const Authorization = useCallback(() => {
        let Data = chgData
        api.post('/api/v2/resource', {
            type: 'authorization',
            data: Data,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setUpdate(Date.now())
                    setPage('all')
                    message.success('已写入授权')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [chgData])


    return (
        <div>
            <div style={{ display: page === 'all' ? '' : 'none' }}>
                <Button onClick={() => {
                    setPage('create')
                }} style={{ float: 'right', marginBottom: 20 }}>创建资源托管</Button>
                <div style={{ clear: 'both' }}></div>
                <div style={{ height: 600, overflow: 'auto' }}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        loading={loading}
                    />
                </div>
            </div>


            <div style={{ display: page === 'create' ? '' : 'none' }}>
                <Alert message="暂时不支持 Lua 开发语言托管" type="warning" style={{ marginBottom: 20 }} />

                <div>
                    <Input addonBefore='资源名称' placeholder="请输入资源名称" value={chgAddData.name} style={{ width: 300 }} name='name' onChange={onAddChange} />
                </div>
                <div style={{ marginTop: 20 }}>
                    <Input addonBefore='版本号' placeholder="请输入版本号" value={chgAddData.version} style={{ width: 300 }} name='version' onChange={onAddChange} />
                </div>

                <div>
                    <Button type="primary" style={{ float: 'right' }} onClick={sendData}>创建</Button>
                </div>
            </div>

            <div style={{ display: page === 'details' ? '' : 'none' }}>
                <Descriptions title="资源托管系统-详情">
                    <Descriptions.Item label="托管ID" span={3}>
                        <Paragraph
                            copyable={{
                                text: `${chgData.nid}`,
                            }}
                            style={{ marginBottom: 0 }}
                        >
                            <Tag color="default">{chgData.nid}</Tag>
                        </Paragraph>
                    </Descriptions.Item>
                    <Descriptions.Item label="资源名称" span={3}>
                        <Paragraph
                            editable={{
                                onChange: onChange,
                            }}
                            style={{ width: 400, margin: 0 }}
                        >
                            {chgData.name}
                        </Paragraph>
                    </Descriptions.Item>
                    <Descriptions.Item label="版本号" span={3}>
                        <Paragraph
                            editable={{
                                onChange: (value) => {
                                    setChgData((data) => ({
                                        ...data,
                                        version: value
                                    }))
                                },
                            }}
                            style={{ width: 400, margin: 0 }}
                        >
                            {chgData.version}
                        </Paragraph>
                    </Descriptions.Item>

                    {/* <Descriptions.Item label="开发语言" span={3}>
                        <Select
                            value={chgData.language}
                            style={{
                                width: 120,
                            }}
                            onChange={handleChange}
                            options={[
                                {
                                    value: 'js',
                                    label: 'Js',
                                },
                                {
                                    value: 'lua',
                                    label: 'Lua',
                                },
                            ]}
                        />
                    </Descriptions.Item> */}
                    <Descriptions.Item label="使用数" span={3}>
                        <Tag color="processing">{chgData.useNum}</Tag>
                    </Descriptions.Item>
                    {/* <Descriptions.Item label="代码内容" span={3}>
                        <TextArea rows={8} value={chgData.code} onChange={onCodeChange} />
                    </Descriptions.Item> */}
                    <Descriptions.Item label="生成时间" span={3}>
                        <Tag icon={<ClockCircleOutlined />} color="default">
                            {chgData.ctime}
                        </Tag>
                    </Descriptions.Item>
                </Descriptions>

                <div style={{ marginBottom: 20, marginTop: 20 }}>

                    <Button type="primary" style={{ float: 'right' }} onClick={saveData}>保存</Button>
                    <Button style={{ float: 'right', marginRight: 20 }} onClick={Authorization}>写入自己的授权</Button>
                    <div style={{ clear: 'both' }}></div>
                </div>

                <div style={{ height: 600, overflow: 'auto' }}>
                    <Table
                        columns={columnsUser}
                        dataSource={chgData.users}
                        pagination={false}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>

        </div>
    )
}

export default ChgV2;